module.exports = __webpack_public_path__ + "img/ss_green-06.783247f7.jpg";